export const Global = Object.freeze({
  QAT: "qat",
  UAT: "uat",
  PRD: "prd",
  PROJECTNAME: "jigenpass-b2b",
  AUTHENTICATIONLINK:
    "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=",
  HS256: "HS256",
  SHA256: "sha256",
  UTF8: "utf8",
  DOKOKOKO: "dokokoko",
  DOKOKOKOBO: "dokokoko-bo",
  JIGENPASS: "jigenpass",
  JIGENPASSBO: "jigenpass-bo",
  JIGENPASSB2B: "jigenpass-b2b",
  MEMBERSHIP: "membership",
  SYSTEM: "system",
  ACCESS: "access",
  REFRESH: "refresh",
  ACCESSTOKEN: "accessToken",
  REFRESHTOKEN: "refreshToken",
  ANONYMOUS: "anonymous",
  AUTH: {
    VERIFICATION_EXPIRY_HOURS: 24,
    RESET_PASSWORD_EXPIRY_HOURS: 1,
  },
  CACHE_TTL: {
    PRODUCT: 30000,
    PRODUCT_LIST: 5000,
    BRAND: 60000,
    IP: 60000,
    CATEGORY: 60000,
    ORDER: 30000,
    INVENTORY: 60000,
    EXCHANGE_RATE: 300000,
    AUTH_TOKEN: 5000,
    AUTH_REQUEST: 2000,
    MAX_SIZE: 1000,
    USERS: 300000,
    NOTIFICATIONS: 60000,
    CROSS_PROJECT: 300000,
  },
  PAGINATION: {
    DEFAULT_PAGE: 1,
    DEFAULT_PER_PAGE: 10,
    PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
    MAX_FETCH: 1000,
  },
  FIXED: "fixed",
  PERCENT: "percent",
  REALTIME: "realtime",
  CREDIT: "credit",
  DEBIT: "debit",
  EXTERNAL: "external",
  INTERNAL: "internal",
  B2B_PRE_ORDER: "B2BPreOrder",
  B2B_ORDER: "B2BOrder",
  INCREASE: "increase",
  DECREASE: "decrease",
  B2B: "b2b",
  BO: "bo",
  B2C: "b2c",
  SST: "SST",
  GST: "GST",
  DEFAULT_REDEMPTION_REFERENCE: "Manual Redemption",
  EXPORT_FILENAME_PREFIX: "Cyber_Transactions_",
  JIGENPASS_B2B_CART_COOKIE: "jigenpass_b2b_cart",
  CART_STORAGE_KEY: "jigenpassCart",
  JIGENPASS_CLIENT_TOKEN: "jigenpassClientToken",
  INVENTORY: {
    LOCK_EXPIRY_MS: 900000,
  },
  DEFAULT_COIN_CONVERSION_RATE: 100,
  COIN_EXPIRY_YEARS: 1,
  SYSTEM_IDENTIFIER: "JigenPass_Enterprise_v1",
  REGEX: {
    SLUG: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
  },
  EXCHANGE_RATE: 1,
  FIRESTORE_BATCH_LIMIT: 450,
  INITIAL_POINTS_DEFAULT: 100,
  LINEITEM: "lineItem",
});

export const SortOrder = Object.freeze({
  ASC: "asc",
  DESC: "desc",
});

export const ValidOrders = Object.freeze([SortOrder.ASC, SortOrder.DESC]);

export const ProjectOptions = Object.freeze([
  { value: Global.JIGENPASS, label: "Jigen Pass (Main Client)" },
  { value: Global.JIGENPASSB2B, label: "Jigen Pass B2B Portal" },
  { value: Global.JIGENPASSBO, label: "Jigen Pass Back Office (BO)" },
  { value: Global.DOKOKOKO, label: "Doko Koko Consumer App" },
  { value: Global.DOKOKOKOBO, label: "Doko Koko Back Office" },
]);

export const ProductFilterType = Object.freeze({
  READY_STOCK: "readyStock",
  PRE_ORDER: "preOrder",
  CONSIGNMENT: "consignment",
});

export const LocationType = Object.freeze({
  WAREHOUSE: "warehouse",
});

export const BillingMode = Object.freeze({
  INDIVIDUAL: "individual",
  CONSOLIDATED: "consolidated",
});

export const CreditMode = Object.freeze({
  INDEPENDENT: "independent",
  SHARED: "shared",
});
